import { isEmpty } from 'validator'
import axios from 'axios'
import config from '../../main/store/_config'
import { axiosUploadImages } from '../../dashboard/actions/imageActions'
import { handleAxiosErrors } from '../_utils'

export const hasEmptyFields = (fields) => {
  let values = []
  Object.entries(fields).map(([name, field]) => {
    if (field !== null) {
      values.push(field.input.value)
    }
  })
  if (!values.length) return true
  return values.some((value) => isEmpty(String(value)))
}
export const validateFields = (fields) => {
  let flag = true
  Object.entries(fields).map(([name, field]) => {
    if (field !== null && !field.validate()) {
      field.setState({
        displayError: true,
      })
      flag = false
    }
  })
  return flag
}

/**
 *
 * @param {*} LocationId
 * @param {*} postalCode
 * @returns array of suburbs
 */
export const axiosGetSuburbList = (LocationId, postalCode) => {
  const { url, query } = config.registration.subUrbs.threePlReadSuburbs
  const variables = { LocationID: LocationId, PostCode: postalCode }

  return axios.get(url, {
    params: {
      query: query,
      variables: variables,
    },
    withCredentials: true,
  })
}

export const postApplyFormData = (postData) => {
  return async (dispatch, getState) => {
    let { url, query } = config.careers.applyForJob
    try {
      let uploadImageID = await axiosUploadImages(postData?.ResumeID)

      if (uploadImageID) {
        postData.ResumeID = uploadImageID

        let finalResponse = await axios.post(
          url,
          {
            query: query,
            variables: { Input: postData },
          },
          {
            withCredentials: true,
          }
        )

        return finalResponse
      }
    } catch (err) {
      handleAxiosErrors(err)
    }
  }
}
